/**
 * Admin → Platform Config (Apprise product): read-only list of the active VM image
 * catalog the wizard offers. Images are managed in the Django admin (VmImage);
 * none is verified for Apprise unless an administrator marks it so.
 */
import { useAppriseVmOptions } from '@/hooks/useProducts'
import { Badge } from './AppriseFields'

export function AppriseImageCatalog() {
  const { data, isLoading, isError } = useAppriseVmOptions(true)
  const images = data?.images ?? []
  return (
    <div>
      <div style={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--aptean-text-muted)', marginBottom: 8 }}>
        VM image catalog (read-only)
      </div>
      {isLoading ? (
        <div style={{ fontSize: '0.8125rem', color: 'var(--aptean-text-muted)' }}>Loading images…</div>
      ) : isError || images.length === 0 ? (
        <div style={{ fontSize: '0.8125rem', color: 'var(--aptean-text-muted)' }}>No images could be loaded.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {images.map((i) => (
            <div key={i.id} style={{ fontSize: '0.8125rem', color: 'var(--aptean-text-secondary)' }}>
              <strong>{i.label}</strong> · {i.os_type}
              {!i.verified_for_product && <Badge>Not verified for Apprise</Badge>}
              <div style={{ fontFamily: 'var(--aptean-font-mono)', fontSize: '0.75rem', color: 'var(--aptean-text-muted)' }}>
                {i.publisher}:{i.offer}:{i.sku}:{i.version}
              </div>
            </div>
          ))}
        </div>
      )}
      <div style={{ marginTop: 8, fontSize: '0.75rem', color: 'var(--aptean-text-muted)' }}>
        Manage images in the Django admin (VM images). Existence and compatibility are re-checked in the pipeline preflight.
      </div>
    </div>
  )
}
